import { Button, Group, Stack, Text, ThemeIcon } from "@mantine/core";
import {
  IconArrowBounce,
  IconColumns,
  IconDeviceDesktopAnalytics,
  IconFolderOpen,
  IconLink,
  IconTag,
  IconTools,
} from "@tabler/icons-react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useListStore } from "../../../../stores/ListStore";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useProfileStore } from "../../../../stores/UserStore";
import { getPermission } from "../../../../functions/utilFunctions";

const Toolbox = () => {
  const lang = useLanguage((s) => s.language);
  const profile = useProfileStore((s) => s.profile);

  useEffect(() => {
    return () => {
      useListStore.getState().setModelMinimized(true);
    };
  }, []);

  const tools = [
    {
      icon: <IconFolderOpen size={64} />,
      label: lang.settings.tool_files,
      path: "files",
    },
    {
      icon: <IconLink size={64} />,
      label: lang.settings.tool_links,
      path: "links",
    },
    {
      icon: <IconTag size={64} />,
      label: lang.settings.tool_tags,
      path: "tags",
    },
    {
      icon: <IconColumns size={64} />,
      label: lang.settings.tool_datafields,
      path: "datafields",
    },
  ];

  if (profile?.level === "admin") {
    tools.push({
      icon: <IconArrowBounce size={64} />,
      label: "Supprimer des bounces",
      path: "bounces",
    });
  }

  if (
    profile?.level === "admin" ||
    getPermission("displayEnrichExternalUsageStatistics")
  ) {
    tools.push({
      icon: <IconDeviceDesktopAnalytics size={64} />,
      label: "Statistiques d'enrichissement externe",
      path: "enrich-usage",
    });
  }

  return (
    <Stack gap={0} pr={48} pt={16} h={"calc(100vh - 96px)"}>
      <Group gap={"md"}>
        <Text size="xl" fw={600} mr={"auto"}>
          {lang.settings.links.toolbox}
        </Text>
      </Group>

      <Group mt={32} gap={"xl"}>
        {tools.map((item) => (
          <Button
            key={item.path}
            variant="white"
            h={200}
            w={"40%"}
            component={Link}
            to={item.path}
          >
            <Stack justify="center" align="center">
              <ThemeIcon variant="subtle" size={64}>
                {item.icon}
              </ThemeIcon>

              <Text fw={600} size="lg">
                {item.label}
              </Text>
            </Stack>
          </Button>
        ))}
      </Group>
    </Stack>
  );
};

export default Toolbox;
